import { useEffect } from "react";

/**
 * Calls `handler` when the user mousedowns or touchstarts outside any of the refs.
 * Pass a single ref or an array of refs.
 */
export default function useClickOutside(refs, handler, when = true) {
  useEffect(() => {
    if (!when) return;
    const refList = Array.isArray(refs) ? refs : [refs];

    const onPointerDown = (e) => {
      const target = e.target;
      const inside = refList.some((r) => r?.current && r.current.contains(target));
      if (!inside) handler(e);
    };

    document.addEventListener("mousedown", onPointerDown);
    document.addEventListener("touchstart", onPointerDown);
    return () => {
      document.removeEventListener("mousedown", onPointerDown);
      document.removeEventListener("touchstart", onPointerDown);
    };
  }, [refs, handler, when]);
}
